export default "__VITE_ASSET__arnWuowz__"